import { useEffect } from 'react';
import { useState } from 'react';
import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Spin, Button, Card, Timeline, message, Modal } from 'antd';

import sessionManager, { eVariableType } from '../../../SessionManager';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import OpportunitaAttivita from './OpportunitaAttivita';
import OpportunitaAttivitaAddEdit from './OpportunitaAttivitaAddEdit';

export default function OpportunitaAttivitaElenco(props) {
    const [openAddEdit, setOpenAddEdit] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [attivita, setAttivita] = useState(null);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        async function loadAttivita() {
            try {
                setIsLoadingSave(true);

                const result = await api.get(
                    'CRM/Opportunita/AttivitaEventiOpportunita?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&idOpportunita=' +
                        props?.idOpportunita
                );

                if (result != null && result.data != null) {
                    setAttivita(result.data);
                } else {
                    message.error(result.statusText);
                }
            } catch (error) {
                message.error(error.response.data.message);
            } finally {
                setIsLoadingSave(false);
            }
        }

        loadAttivita();
    }, [reload, props]);

    function onClickAddAttivita() {
        setOpenAddEdit(true);
    }

    function GetColor(item) {
        const dscad = new Date(item.dataUltima).getTime();

        if (item.tipo === 'E') return 'gray';
        if (dscad === 0) return 'green';

        if (Date.now() >= dscad) return 'red';
        else return 'green';
    }

    function funcreload() {
        setReload(!reload);
    }
    function conferma(e) {
        setOpenAddEdit(false);
        if (e) setReload(!reload);
    }

    const itemsTimeline = attivita
        ? attivita.map((item) => ({
              key: item.id,
              color: GetColor(item),
              children: <OpportunitaAttivita item={item} reload={funcreload} />,
          }))
        : [];

    return (
        <div>
            <Spin spinning={isLoadingSave}>
                <Card
                    title={stringres.t('attivita')}
                    extra={
                        <Button onClick={onClickAddAttivita}>
                            <PlusOutlined />
                        </Button>
                    }
                >
                    <Timeline items={itemsTimeline}></Timeline>
                </Card>
                <Modal
                    destroyOnClose="true"
                    title={stringres.t('attivitaaddedit')}
                    open={openAddEdit}
                    onCancel={() => setOpenAddEdit(false)}
                    footer={null}
                >
                    <OpportunitaAttivitaAddEdit
                        idOpportunita={props?.idOpportunita}
                        confirm={conferma}
                    ></OpportunitaAttivitaAddEdit>
                </Modal>
            </Spin>
        </div>
    );
}
